// An item is divided into `splits` equal portions (the denominator, owner-set,
// default 1). `shares` maps a roster user's id to how many of those portions
// they took (the numerator). A person pays price * (shares[id] / splits).
export type ItemUI = {
  id: string;
  name: string;
  price: number;
  splits: number;
  shares: Record<string, number>;
};

export const emptyItem: ItemUI = {
  id: "",
  name: "",
  price: 0,
  splits: 1,
  shares: {},
};

export function createNewItem(name: string, price: number) {
  return {
    id: crypto.randomUUID(),
    name,
    price,
    splits: 1,
    shares: {},
  } as ItemUI;
}
